import React from "react";

export const Container = ({ className = "", children, narrow = false }) => (
  <div
    className={`mx-auto w-full px-4 sm:px-6 ${narrow ? "max-w-3xl" : "max-w-6xl"} ${className}`}
  >
    {children}
  </div>
);

// A page section with an optional eyebrow / title / lead, centered.
export const Section = ({
  id,
  eyebrow,
  title,
  lead,
  className = "",
  children,
  narrow,
}) => (
  <section id={id} className={`py-14 md:py-20 scroll-mt-20 ${className}`}>
    <Container narrow={narrow}>
      {(eyebrow || title || lead) && (
        <header className="text-center max-w-2xl mx-auto mb-10 md:mb-12">
          {eyebrow && (
            <p className="text-primary text-sm font-bold mb-2">{eyebrow}</p>
          )}
          {title && (
            <h2 className="text-white text-2xl md:text-4xl font-extrabold leading-tight">
              {title}
            </h2>
          )}
          {lead && (
            <p className="text-white/70 text-base md:text-lg mt-3 leading-relaxed">
              {lead}
            </p>
          )}
        </header>
      )}
      {children}
    </Container>
  </section>
);

export const Badge = ({ tone = "gold", className = "", children }) => {
  const tones = {
    gold: "bg-primary/15 text-primary border-primary/30",
    copper: "bg-mainButton/15 text-lightBrown border-mainButton/40",
    success: "bg-success/15 text-success border-success/40",
    muted: "bg-white/10 text-white/80 border-white/15",
  };
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-bold ${tones[tone] || tones.gold} ${className}`}
    >
      {children}
    </span>
  );
};
